
import React, { useState } from "react";
import "./WhyChooseSection.css";

const WhyChooseSection = () => {
  const [activeTab, setActiveTab] = useState("nurturing");
  const [showAbout, setShowAbout] = useState(false);

  const tabData = {
    nurturing: {
      tag: "Holistic Foundation",
      title: "For a Better Tomorrow",
      description:
        "BVM believes that a school's purpose is to guide the child in the discovery of themselves and their world and to identify and nurture their talents. Just as every seed contains the future tree, each child is born with infinite potential.",
      features: [
        {
          icon: "/assets/images/bulb.png",
          title: "Creative Study Pattern",
          desc: "Interactive curriculum designed to spark intellectual curiosity and critical thought."
        },
        {
          icon: "/assets/images/protractor.png",
          title: "Provided with Experimental Examples",
          desc: "Hands-on laboratory demonstrations, STEM workshops, and real-world problem solving."
        }
      ],
      button: "Explore About School",
      link: "#aboutSectionDetail",
      image: "http://localhost:3000/static/media/A%20Space%20That%20Inspires%20Learning%20&%20Growth.jpg.bd9c2fe2ff0dae1e7ecb.jpeg",
      badge: "NABET & IDS Accredited",
      badgeDesc: "Highest Standards of Learning",
      badgeIcon: "✓"
    },

    methodology: {
      tag: "Academic Rigor",
      title: "Methodology",
      description:
        "Practising an innovative system of imparting knowledge enriched with experimental examples, interactive STEM labs, digital classrooms, and inquiry-based learning that inspire students to think critically and solve real-world problems.",
      features: [
        {
          icon: "/assets/images/bulb.png",
          title: "Creative Study Pattern",
          desc: "Empowering independent thinkers capable of articulating original viewpoints."
        },
        {
          icon: "/assets/images/protractor.png",
          title: "Provided with Experimental Examples",
          desc: "Advanced Physics, Chemistry, Biology & Computer Laboratories."
        }
      ],
      button: "Contact Academic Desk",
      link: "#contactSection",
      image: "http://localhost:3000/static/media/1.jpg.2844360670a7968eb942.jpeg",
      badge: "STEM & Robotics",
      badgeDesc: "Experiential 21st-Century Learning",
      badgeIcon: "⚙"
    },

    beyond: {
      tag: "Holistic Growth",
      title: "Beyond Classroom",
      description:
        "We, at Bharatiya Vidya Bhavan, help our students engage in collaborative learning opportunities. From industrial visits to IIM Nagpur to cultural and sports competitions, education extends beyond textbook walls to sculpt well-rounded personalities.",
      features: [
        {
          icon: "/assets/images/bulb.png",
          title: "Creative Study Pattern",
          desc: "Leadership training through Scouts & Guides, NCC, and Student Council."
        },
        {
          icon: "/assets/images/protractor.png",
          title: "Provided with Experimental Examples",
          desc: "Industrial tours, social outreach, and prestigious national competitions."
        }
      ],
      button: "View Campus Events",
      link: "#calendarEventsSection",
      image: "http://localhost:3000/static/media/5.jpg.a6ef33d899345673de00.jpeg",
      badge: "130+ Active Clubs",
      badgeDesc: "Arts, Sports, Music & Debates",
      badgeIcon: "🏆"
    }
  };

  const current = tabData[activeTab];

  return (
    <section className="why-choose-showcase" id="whyChooseSection">
      <div className="why-container">

        {/* Section Heading */}
        <div className="why-heading">

          <h2 className="section-title-modern">
            Why Choose <span>Airforce</span>
          </h2>

          <p className="section-subtitle-modern text-center" >
            Unleash your child’s potential
          </p>

          {/* Tabs */}
          <div className="segmented-pill-nav" role="tablist">
            <button
              className={activeTab === "nurturing" ? "seg-pill-btn active" : "seg-pill-btn"}
              onClick={() => setActiveTab("nurturing")}
            >
              <i className="bi bi-heart-pulse-fill"></i>
              Nurturing Learners
            </button>

            <button
              className={activeTab === "methodology" ? "seg-pill-btn active" : "seg-pill-btn"}
              onClick={() => setActiveTab("methodology")}
            >
              <i className="bi bi-lightbulb-fill"></i>
              Methodology
            </button>

            <button
              className={activeTab === "beyond" ? "seg-pill-btn active" : "seg-pill-btn"}
              onClick={() => setActiveTab("beyond")}
            >
              <i className="bi bi-compass-fill"></i>
              Beyond Classrooms
            </button>
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab-bento-card" key={activeTab}>
          <div className="why-content-grid">

            {/* Left Content */}
            <div className="why-text-content">

              <span className="why-category-tag">
                {current.tag}
              </span>

              <h3>{current.title}</h3>

              <p className="why-description">
                {current.description}
              </p>

              {current.features.map((feature, index) => (
                <div className="feature-pill-box" key={index}>
                  <div className="feature-icon-wrap">
                    <img src={feature.icon} alt="" />
                  </div>

                  <div>
                    <h5>{feature.title}</h5>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}

              <a
                href={current.link}
                className="btn-nav-admission"
                onClick={
                  activeTab === "nurturing"
                    ? (e) => {
                        e.preventDefault();
                        setShowAbout(!showAbout);
                      }
                    : undefined
                }
              >
                {current.button}
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>

            {/* Right Image */}
            <div className="why-image-content">
              <div className="layered-media-stack">
                <div className="media-stack-primary">
                  <img
                    src={current.image}
                    alt={current.title}
                    key={current.image}
                  />
                </div>

                <div className="media-stack-badge-chip">
                  <div className="badge-icon">
                    {current.badgeIcon}
                  </div>

                  <div>
                    <h6>{current.badge}</h6>
                    <small>{current.badgeDesc}</small>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* About School Expand */}
        {showAbout && (
          <div className="about-school-expand">
            <button
              className="about-close"
              onClick={() => setShowAbout(false)}
              aria-label="Close about section"
            >
              ×
            </button>

            <h5>
              About Bharatiya Vidya Bhavan's Bhagwandas Purohit Vidya Mandir
            </h5>

            <p>
              BVM Trimurti Nagar was established to carry forward the
              timeless vision of Dr. K. M. Munshi. Affiliated to CBSE,
              New Delhi (Affiliation No: 1130084, School Code: 30040),
              the institution provides high-standard education
              integrating modern academic disciplines with Indian
              cultural roots, accredited with NABET and British Council IDS.
            </p>
          </div>
        )}

      </div>
    </section>
  );
};

export default WhyChooseSection;
